export default __webpack_public_path__ + "static/media/clife-icon-48px.5b249ece.svg";